import { useEffect } from "react";
import { APP_COMPANY_COLOR } from "consts";
import { getContrastColor } from "./utils";

// Set dynamic favicon based on company color
export const useDynamicFavicon = (color: string = APP_COMPANY_COLOR) => {
  useEffect(() => {
    const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="40 40 560 560" width="64" height="64"><rect x="270" y="96" width="100" height="448" fill="${getContrastColor(color)}"></rect><path fill="${color}" d="M287.9 96h-76.2c-29.4 0-55.1 20.1-62.1 48.6L65.4 484.5C57.9 514.7 80.8 544 112 544h175.9v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64H528c31.2 0 54.1-29.3 46.6-59.5l-84.1-339.9c-7.1-28.5-32.7-48.6-62.2-48.6h-76.4v64c0 17.7-14.3 32-32 32s-32-14.3-32-32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32"></path></svg>`;
    const blob = new Blob([svgContent], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = 64;
      canvas.height = 64;
      canvas.getContext("2d")?.drawImage(img, 0, 0, 64, 64);

      URL.revokeObjectURL(url);
      document.querySelectorAll("link[rel*='icon']").forEach((el) => el.remove());

      const link = document.createElement("link");
      link.rel = "icon";
      link.href = canvas.toDataURL("image/png");

      document.head.appendChild(link);
    };

    img.src = url;
  }, [color]);
};
